import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SideMenu from "../SideMenu";
import Table from "./Table";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Nav from "../../Common/Nav";
import Footer from "../../Common/Footer";
import RequireLogin from "../../../permissions.js/RequireLogin";
import Cookies from "js-cookie";
import PageLoader from "../../Common/PageLoader";
import { Types } from "../../../utils/Types"

function Household() {
  const [isLoading, setIsLoading] = useState(false);
  const [spouses, setSpouses] = useState([]);
  const [children, setChildren] = useState([]);
  const [refreshFlag, setRefreshFlag] = useState(0);

  const fetchData = () => {
    const userid = Cookies.get("hippocratic_portal_contactid");

    setIsLoading(true);
    getApiClient()
      .getMembers(userid)
      .then((res) => {
        if (res.data) {
          const spouseMembers = res.data.members.filter(
            (member) => member.contactid != userid && member.Type == 0
          );
          setSpouses(spouseMembers);

          const childrenMembers = res.data.members.filter(
            (member) => member.contactid != userid && member.Type == 1
          );
          setChildren(childrenMembers);
        }
      })
      .catch(makeStandardApiErrorHandler((error) => console.log(error)))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, [refreshFlag]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; Household
          </NavigationInformation>
          <Title>Household</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          <RightContainer>
            {spouses && <Table data={spouses} name={Types.SPOUSE} add={Types.SPOUSE} onRefresh={() => setRefreshFlag(prev => prev + 1)} />}
            {children && (
              <Table
                data={children}
                name={Types.CHILD}
                color={"#FBC67D26"}
                add={Types.CHILD}
                onRefresh={() => setRefreshFlag(prev => prev + 1)}
              />
            )}
          </RightContainer>
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 50vh;
  gap: 20px;
`;

export default RequireLogin(Household);
